/* eslint-disable */
import { useEffect } from 'react';
import DarkImg from 'src/assets/images/theme-dark.png';
import LightImg from 'src/assets/images/theme-light.png';
import useTheme from 'src/hooks/useTheme';
import useHistory from 'src/hooks/useHistory';
import './index.scss';

const ThemeSwitch = () => {
  const { theme, setTheme, themeKey } = useTheme();
  const { searchParams, updateSearchParams } = useHistory();

  const isDarkTheme = theme === 'dark';

  useEffect(() => {
    updateSearchParams(themeKey, theme);
  }, [searchParams, theme, updateSearchParams]);

  return (
    <div
      className={`theme-switch theme-switch--${isDarkTheme ? 'dark' : 'light'}`}
      onClick={() => setTheme(theme !== 'dark' ? 'dark' : 'light')}
    >
      <div className={isDarkTheme ? 'checked' : ''}>
        <img src={isDarkTheme ? DarkImg : LightImg} />
      </div>
    </div>
  );
};

export default ThemeSwitch;
